const hideNavbar = {
    login: true,
    register: true,
    passwordReset: true,
    fourHundredFour: true,
};

export default hideNavbar;



// WEBPACK FOOTER //
// ./src/common/constants/hideNavbar.js